import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "spinner", "saveButton", "checkIcon", "buttonText"]

  connect() {
    // Initialize the controller
  }

  saveChanges() {
    const changes = {}
    this.radioTargets.forEach(radio => {
      if (radio.checked) {
        changes[radio.dataset.graphName] = radio.value
      }
    })

    if (Object.keys(changes).length === 0) {
      return
    }

    this.showSpinner()
    this.hideSuccessState()

    fetch(`/journals/${window.location.pathname.split('/').pop()}/update_graph_status`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        changes: changes
      })
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessState()
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
    .finally(() => {
      this.hideSpinner()
    })
  }

  resetSaveButton() {
    this.hideSuccessState()
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('d-none')
  }

  hideSpinner() {
    this.spinnerTarget.classList.add('d-none')
  }

  showSuccessState() {
    this.saveButtonTarget.classList.remove('btn-primary')
    this.saveButtonTarget.classList.add('btn-success')
    this.checkIconTarget.classList.remove('d-none')
    this.buttonTextTarget.textContent = 'Saved'
  }

  hideSuccessState() {
    this.saveButtonTarget.classList.remove('btn-success')
    this.saveButtonTarget.classList.add('btn-primary')
    this.checkIconTarget.classList.add('d-none')
    this.buttonTextTarget.textContent = 'Save Changes'
  }
}
